module.exports = __webpack_public_path__ + "img/logo_pleisure_row_white.fdde1dd7.png";